import {FETCHED_BLAKE} from '../../types';
import callBC from '../../helpers/bc'

export async function getBlake(dispatch,state){
  let wallet = state.passport.wallet;
  let data = await callBC(state.settings.settings,'getBlake2bl',[wallet.emb.address.toLowerCase(),1])

  data = await callBC(state.settings.settings,'getBlake2bl',[data.result.hash+wallet.emb.address.toLowerCase(),1])

  dispatch({
    type: FETCHED_BLAKE,
    payload: '0x'+data.result.hash,
  });

  return '0x'+data.result.hash
}
